import clsx from 'clsx';
import React from 'react';

export interface NoOpQueryResultBoxProps {
  className?: string;
  showingInsideCard?: boolean;
}

export function NoOpQueryResultBox({
  className = '',
  showingInsideCard
}: NoOpQueryResultBoxProps) {
  return (
    <div className={clsx('box', showingInsideCard ? 'box--inside-card' : '', className)}>
      <div className='box__header border-bottom-0'>
        <div className='box__title'>
          <span>
            Query Result
            <b className='ml-1'>
              Operation Successful
            </b>
          </span>
        </div>
      </div>
    </div>
  );
}
